import NAV_DATA from '@zola-helpers/client/dist/es/constants/navConstants';

import weddingCosts from 'assets/images/navigation/five_ways_wedding_costs.jpg';
import std from 'assets/images/navigation/guide_std.jpg';
import planWedding from 'assets/images/navigation/how_plan_wedding.jpg';
import cake from 'assets/images/navigation/wedding_cake_ideas.jpg';

import type { MegaMenuNavItem, MenuMenuSectionItem } from './types';

const {
  PRIMARY: { ADVICE },
} = NAV_DATA;

const getAdvice = (): MegaMenuNavItem => {
  const categoryChildren: MenuMenuSectionItem[] = [
    {
      title: 'Planning 101',
      path: '/expert-advice/topic/planning-101',
    },
    {
      title: 'Decor + Inspiration',
      path: '/expert-advice/topic/decor-inspiration',
    },
    {
      title: 'Invites + Paper',
      path: '/expert-advice/topic/invites-paper',
    },
    {
      title: 'Wedding Party',
      path: '/expert-advice/topic/wedding-party',
    },
    {
      title: 'Pre-Wedding Activities',
      path: '/expert-advice/topic/pre-wedding-activities',
    },
    {
      title: 'The First Look Report',
      path: '/expert-advice/topic/first-look-report',
    },
    {
      title: 'Registry',
      path: '/expert-advice/topic/registry',
    },
    {
      title: 'Wedding Guests',
      path: '/expert-advice/topic/wedding-guests',
    },
    {
      title: 'Honeymoons',
      path: '/expert-advice/topic/honeymoon',
    },
    {
      title: 'Newlywed Life',
      path: '/expert-advice/topic/newlywed-life',
    },
    {
      title: 'COVID-19',
      path: '/expert-advice/topic/covid-19',
    },
  ];

  const featuredChildren: MenuMenuSectionItem[] = [
    {
      title: 'A Guide to Save the Dates',
      path: '/expert-advice/a-guide-to-save-the-dates',
      thumbnail: std,
    },
    {
      title: '5 Ways to Cut Wedding Costs',
      path: '/expert-advice/5-ways-cut-wedding-costs',
      thumbnail: weddingCosts,
    },
    {
      title: 'How to Plan a Wedding',
      path: '/expert-advice/how-to-plan-a-wedding',
      thumbnail: planWedding,
    },
    {
      title: 'Wedding Cake Ideas',
      path: '/expert-advice/wedding-cake-ideas',
      thumbnail: cake,
    },
  ];

  return {
    title: 'Advice',
    id: ADVICE,
    parent: 'Advice',
    path: '/expert-advice',
    children: [
      {
        headline: 'What do you need help with?',
        twoColumns: true,
        children: categoryChildren,
      },
      {
        headline: 'Keep Calm and Read On',
        borderLeft: true,
        children: featuredChildren,
      },
    ],
  };
};

export default getAdvice;
